export const formatIntegerInput = (value) => {
  if (value === undefined || value === null || value === '') return '';
  return `${value}`.replace(/\D/g, '').replace(/\B(?=(\d{3})+(?!\d))/g, '.');
};

export const parseIntegerInput = (value) => `${value ?? ''}`.replace(/\D/g, '');
